// Duits (de-DE), Einstellungen · Mitteilungen (0038_meldingen): zelfde vorm als pushApp.nl.ts.
// Du-vorm, zoals de rest van de Duitse ouderapp. De server herkent gevoelige woorden in het
// Nederlands, Engels en Turks (packages/domain/src/push/sensitive.ts); de uitleg zegt dat eerlijk.
export const appPushDe = {
    title: 'Mitteilungen',
    subtitle: 'Kleine Hinweise auf deinem Handy. Du wählst, was du bekommst.',
    settingsBody: 'Erinnerungen, Fahrten und Nachrichten auf deinem Handy',
    device: {
        title: 'Auf diesem Gerät',
        on: 'Mitteilungen sind auf diesem Gerät an.',
        off: 'Mitteilungen sind auf diesem Gerät noch aus.',
        turnOn: 'Mitteilungen einschalten',
        turnOff: 'Auf diesem Gerät ausschalten',
        test: 'Testmitteilung senden',
        testSent: 'Testmitteilung gesendet. Sie kommt gleich an.',
        testNone: 'Es ist noch kein Handy angemeldet.',
        testOff: 'Das Senden ist auf diesem Server ausgeschaltet.',
        turnedOn: 'Mitteilungen sind an',
        turnedOff: 'Mitteilungen sind auf diesem Gerät aus',
        denied: 'Dein Browser blockiert Mitteilungen von AMUMIN. Erlaube sie in den Einstellungen deines Browsers oder Handys und komm dann zurück.',
        unsupported: 'Dieser Browser kann keine Mitteilungen empfangen.',
        nativeApp: 'In der iPhone-App von AMUMIN kommen noch keine Mitteilungen an. Möchtest du sie schon jetzt? Öffne AMUMIN in Safari und lege es auf deinen Home-Bildschirm.',
        unavailable: 'Mitteilungen sind noch nicht eingerichtet. Versuch es später noch einmal.',
        needsInstall: 'Auf iPhone und iPad kommen Mitteilungen nur an, wenn AMUMIN auf deinem Home-Bildschirm liegt. Leg es zuerst dort ab (siehe unten) und öffne AMUMIN dann vom Home-Bildschirm aus.',
        notAllowedChild: 'Ein Elternteil schaltet Mitteilungen für dich ein.',
        inUse: 'Dieser Browser ist schon für jemand anderen in eurer Familie angemeldet.',
        nothingChosen: 'Du hast nichts ausgewählt, es kommen keine Mitteilungen.',
        loginNote: 'Mitteilungen kommen, solange du auf diesem Gerät angemeldet bist. Meldest du dich ab, hören sie auf.',
    },
    install: {
        title: 'Leg AMUMIN auf deinen Home-Bildschirm',
        body: 'Dann öffnest du AMUMIN mit einem Tipp, wie eine App. Es kostet nichts und du musst nichts herunterladen.',
        installed: 'AMUMIN liegt auf deinem Home-Bildschirm.',
        platform: 'Welches Gerät?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Computer',
        iosNote: 'Mitteilungen funktionieren ab iOS 16.4, wenn AMUMIN auf deinem Home-Bildschirm liegt.',
        androidButton: 'AMUMIN installieren',
        desktopButton: 'AMUMIN installieren',
    },
    kinds: {
        title: 'Was möchtest du bekommen?',
        autosave: 'Was du ankreuzt, wird sofort gespeichert.',
        reminders: 'Meine Erinnerungen',
        remindersHint: 'Im selben Moment, in dem das Tablet ruft.',
        remindersChildren: 'Auch die Erinnerungen meiner Kinder',
        rides: 'Fahrten',
        ridesHint: '„Wer bringt Yakub morgen um 08:15?“ und wer eine Fahrt übernimmt.',
        approvals: 'Was auf mein Ja wartet',
        approvalsHint: 'Zusammen in einer Mitteilung, höchstens einmal pro halbe Stunde.',
        messages: 'Neue Nachrichten',
        departure: 'Zeit zum Losgehen',
        departureHint: 'Wenn beim Termin eine Fahrzeit steht.',
        summary: 'Tagesüberblick',
        summaryHint: 'Jeden Tag eine kurze Zusammenfassung des Kalenders.',
        summaryAt: 'Um',
    },
    quiet: {
        title: 'Ruhezeiten',
        toggle: 'Keine Mitteilungen in den Ruhezeiten',
        from: 'Von',
        to: 'Bis',
        note: 'Erinnerungen, die du selbst für dich angelegt hast, kommen trotzdem.',
    },
    discreet: {
        title: 'Diskret auf dem Sperrbildschirm',
        body: 'Mitteilungen gehen verschlüsselt über den Dienst von Apple, Google, Mozilla oder Microsoft. Der kann sie nicht lesen. Aber auf deinem Sperrbildschirm kann jeder mitlesen. Deshalb steht dort standardmäßig nur „AMUMIN“ und welche Art von Mitteilung es ist.',
        all: 'Alles diskret',
        allHint: 'Standardmäßig an. Du siehst nur „AMUMIN“ mit „Eine Erinnerung“, „Etwas zum Bringen und Abholen“, „Etwas wartet auf dein Ja“ oder „Eine neue Nachricht“. Schaltest du das aus, siehst du Details: den Titel, Namen, die Uhrzeit, den Ort und den Text einer Nachricht.',
        sensitive: 'Glaube, Gesundheit und Schule diskret',
        sensitiveHint: 'Auch mit Details: Erkennen wir am Symbol oder an bestimmten Wörtern (auf Niederländisch, Englisch und Türkisch), dass es bei einem Termin, einer Erinnerung oder Nachricht um Gesundheit, Glauben oder Schule geht, bleibt die Mitteilung diskret. Keine Wortliste ist vollständig: Im Zweifel lass alles diskret.',
    },
    children: {
        title: 'Kinder',
        body: 'Ein Kind mit eigenem Login kann auch Mitteilungen bekommen, wenn du einverstanden bist. Standardmäßig ist das aus.',
        allow: 'Mitteilungen für {name}',
        noLogin: '{name} hat kein eigenes Login.',
        none: 'In eurer Familie gibt es noch keine Kinder.',
        toastOn: '{name} darf jetzt Mitteilungen bekommen',
        toastOff: '{name} bekommt keine Mitteilungen mehr',
    },
    devices: {
        title: 'Deine Handys und Browser',
        none: 'Noch kein Handy oder Browser angemeldet.',
        since: 'Angemeldet am {date}',
        lastUsed: 'Letzte Mitteilung {date}',
        error: 'Die letzte Mitteilung ist nicht angekommen.',
        remove: 'Entfernen',
        removeLabel: '{name} entfernen',
        removed: 'Entfernt',
        thisOne: 'Dieses',
    },
    save: 'Speichern',
    saved: 'Gespeichert',
    offTitle: 'Mitteilungen sind aus',
    offBody: 'Mitteilungen sind für eure Familie aus. Ein Elternteil schaltet sie unter Module ein.',
};
//# sourceMappingURL=pushApp.de.js.map